module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3579.56929,341.603268 C3579.46619,343.924909 3577.80309,345.166893 3576.13933,347.856147 C3574.19814,350.993841 3574.19975,356.729357 3572,361.507704 C3572.54236,362.639442 3576.10182,360.653891 3576.88259,358.73066 C3577.66336,356.807429 3578.25928,355.243365 3578.52347,354.758988 C3578.78766,354.274611 3579.3988,354.328387 3579.56882,354.799413 C3579.73884,355.270439 3579.58855,372.190949 3579.9424,373.031892 C3580.29625,373.872835 3582.42408,373.971682 3582.82301,373.125799 C3583.22194,372.279916 3583.67133,358.903024 3583.86438,358.550895 C3584.05744,358.198766 3584.51897,358.386323 3584.7096,358.578449 C3584.90022,358.770574 3584.0262,373.047382 3584.32423,373.589442 C3584.62226,374.131501 3586.82435,374.111038 3587.07857,373.679232 C3587.33279,373.247426 3587.94599,359.007677 3588.19713,358.692141 C3588.44827,358.376605 3588.93133,358.428604 3589.11879,358.722187 C3589.30626,359.01577 3588.25357,372.712938 3588.57421,373.313286 C3588.89484,373.913633 3591.02625,373.992426 3591.24473,373.400344 C3591.46321,372.808262 3592.4132,359.030165 3592.62717,358.836558 C3592.84113,358.642952 3593.1182,358.670745 3593.30819,358.85876 C3593.49819,359.046774 3593.32192,369.354876 3593.64114,369.925838 C3593.96037,370.4968 3595.56877,370.681685 3595.83242,369.997273 C3596.09608,369.312862 3595.89614,344.164093 3595.97982,342.771531 C3596.25868,338.130727 3593.64928,333.188828 3588.05072,333.006317 C3582.45217,332.823806 3579.79069,336.617735 3579.56929,341.603268 Z",
      "id": "boy2_right_hand",
      "fill": "#80A259",
      "transform": "translate(3584.000000, 353.500000) rotate(4.000000) translate(-3584.000000, -353.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3590,284 L3590,284 L3590,284 C3594.41828,284 3598,287.581722 3598,292 L3598,341 L3598,341 C3598,345.418278 3594.41828,349 3590,349 L3590,349 L3590,349 C3585.58172,349 3582,345.418278 3582,341 L3582,292 L3582,292 C3582,287.581722 3585.58172,284 3590,284 Z",
      "id": "boy2_right_arm_bottom",
      "fill": "#80A259",
      "transform": "translate(3590.000000, 316.500000) rotate(4.000000) translate(-3590.000000, -316.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_right_arm_top",
      "fill": "#80A259",
      "transform": "translate(3594.000000, 266.500000) rotate(4.000000) translate(-3594.000000, -266.500000) ",
      "x": "3586",
      "y": "232",
      "width": "16",
      "height": "69",
      "rx": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3595.9555,232.021827 C3600.49212,232.345967 3604.00788,236.204986 3603.99999,240.851714 L3603.95214,269 L3583,267.502976 L3586.78661,239.621824 C3587.41171,235.019194 3591.41888,231.697687 3595.9555,232.021827 Z",
      "id": "boy2_right_sleeve",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_bag_3",
      "fill": "#94B96B",
      "x": "3594",
      "y": "223",
      "width": "74",
      "height": "86",
      "rx": "33"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3591.26364,490 C3587.86936,491.625387 3578.23627,495.365012 3575.92402,496.33481 C3573.61176,497.304608 3570.69814,501.6625 3572.63064,505 C3574.56336,505 3609.10677,505 3612.01737,505 C3613.32754,504.812595 3613.32754,499.812595 3612.01737,490 C3600.5145,490 3593.59659,490 3591.26364,490 Z",
      "id": "boy2_right_shoe",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3601.5,388 L3601.5,388 L3601.5,388 C3608.40356,388 3614,393.596441 3614,400.5 L3614,490 L3589,490 L3589,400.5 L3589,400.5 C3589,393.596441 3594.59644,388 3601.5,388 Z",
      "id": "boy2_right_leg_bottom",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_right_leg_top",
      "fill": "#6D8C4A",
      "x": "3589",
      "y": "307",
      "width": "25",
      "height": "105",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3624.26364,490 C3620.86936,491.625387 3611.23627,495.365012 3608.92402,496.33481 C3606.61176,497.304608 3603.69814,501.6625 3605.63064,505 C3607.56336,505 3642.10677,505 3645.01737,505 C3646.32754,504.812595 3646.32754,499.812595 3645.01737,490 C3633.5145,490 3626.59659,490 3624.26364,490 Z",
      "id": "boy2_left_shoe",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3634.5,388 L3634.5,388 L3634.5,388 C3641.40356,388 3647,393.596441 3647,400.5 L3647,490 L3622,490 L3622,400.5 L3622,400.5 C3622,393.596441 3627.59644,388 3634.5,388 Z",
      "id": "boy2_left_leg_bottom",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3634.5,307 L3634.5,307 L3634.5,307 C3641.40356,307 3647,312.596441 3647,319.5 L3647,399.5 L3647,399.5 C3647,406.403559 3641.40356,412 3634.5,412 L3634.5,412 L3634.5,412 C3627.59644,412 3622,406.403559 3622,399.5 L3622,319.5 L3622,319.5 C3622,312.596441 3627.59644,307 3634.5,307 Z",
      "id": "boy2_left_leg_top",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3589,312 L3647,312 L3647,316 L3647,316 C3647,332.016258 3634.01626,345 3618,345 L3618,345 L3618,345 C3601.98374,345 3589,332.016258 3589,316 L3589,312 Z",
      "id": "boy2_hip",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3606,312 C3607.11353,312 3609.78019,312 3614,312 C3614,326.849226 3614,335.18256 3614,337 C3606.48942,331.607856 3606,325.938632 3606,312 Z",
      "id": "boy2_zipper",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3596.81975,233.040594 C3602.94693,221.934773 3632.4468,222.71187 3639.4081,233.040594 C3644.04897,239.926409 3647.24627,266.246211 3649,312 L3587,312 C3589.46171,266.764276 3592.73496,240.444474 3596.81975,233.040594 Z",
      "id": "boy2_torso",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3633.53521,228 C3636.31047,228 3642.44591,230.941589 3643,233.41859 C3641.16147,253.289562 3638.34124,290.359523 3638.12483,294 C3628.68526,288.668069 3614.22436,239.858231 3633.53521,228 Z",
      "id": "boy2_bag_2",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3592.91069,238.180019 C3594.25148,233.730031 3598.96807,228.525941 3603,228 C3597.79336,246.715263 3591.9326,270.853282 3588,288 C3588.7852,273.669324 3591.09999,244.189618 3592.91069,238.180019 Z",
      "id": "boy2_bag_1",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3632.56929,341.603268 C3632.46619,343.924909 3630.80309,345.166893 3629.13933,347.856147 C3627.19814,350.993841 3627.19975,356.729357 3625,361.507704 C3625.54236,362.639442 3629.10182,360.653891 3629.88259,358.73066 C3630.66336,356.807429 3631.25928,355.243365 3631.52347,354.758988 C3631.78766,354.274611 3632.3988,354.328387 3632.56882,354.799413 C3632.73884,355.270439 3632.58855,372.190949 3632.9424,373.031892 C3633.29625,373.872835 3635.42408,373.971682 3635.82301,373.125799 C3636.22194,372.279916 3636.67133,358.903024 3636.86438,358.550895 C3637.05744,358.198766 3637.51897,358.386323 3637.7096,358.578449 C3637.90022,358.770574 3637.0262,373.047382 3637.32423,373.589442 C3637.62226,374.131501 3639.82435,374.111038 3640.07857,373.679232 C3640.33279,373.247426 3640.94599,359.007677 3641.19713,358.692141 C3641.44827,358.376605 3641.93133,358.428604 3642.11879,358.722187 C3642.30626,359.01577 3641.25357,372.712938 3641.57421,373.313286 C3641.89484,373.913633 3644.02625,373.992426 3644.24473,373.400344 C3644.46321,372.808262 3645.4132,359.030165 3645.62717,358.836558 C3645.84113,358.642952 3646.1182,358.670745 3646.30819,358.85876 C3646.49819,359.046774 3646.32192,369.354876 3646.64114,369.925838 C3646.96037,370.4968 3648.56877,370.681685 3648.83242,369.997273 C3649.09608,369.312862 3648.89614,344.164093 3648.97982,342.771531 C3649.25868,338.130727 3646.64928,333.188828 3641.05072,333.006317 C3635.45217,332.823806 3632.79069,336.617735 3632.56929,341.603268 Z",
      "id": "boy2_left_hand",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3641,284 L3641,284 L3641,284 C3645.41828,284 3649,287.581722 3649,292 L3649,341 L3649,341 C3649,345.418278 3645.41828,349 3641,349 L3641,349 L3641,349 C3636.58172,349 3633,345.418278 3633,341 L3633,292 L3633,292 C3633,287.581722 3636.58172,284 3641,284 Z",
      "id": "boy2_left_arm_bottom",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_left_arm_top",
      "fill": "#80A259",
      "x": "3633",
      "y": "231",
      "width": "16",
      "height": "69",
      "rx": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3640.5,231 L3640.5,231 L3640.5,231 C3645.04591,231 3648.81405,234.52304 3649.11933,239.058689 L3651,267 L3630,267 L3631.88067,239.058689 L3631.88067,239.058689 C3632.18595,234.52304 3635.95409,231 3640.5,231 Z",
      "id": "boy2_left_sleeve",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3608.96658,219.417295 C3609.62547,223.48301 3609.88319,225.10509 3608,227.341418 C3608.48231,228.199356 3611.205,233 3616.03497,233 C3620.86495,233 3624.03548,229.284369 3625,227.341418 C3623.29459,225.050457 3623.38952,223.960041 3624.40203,219.417295 C3623.14384,216.139596 3610.72348,216.249341 3608.96658,219.417295 Z",
      "id": "boy2_neck",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy2_head"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3645.87036,191.060783 C3647.59886,190.027105 3650.08029,188.713961 3652.89371,191.060783 C3655.30019,193.068154 3653.49125,200.943285 3650.245,205.304507 C3647.02952,209.624396 3641.79893,210.521289 3639.74586,208.865438 C3635.41436,218.793185 3624.37523,224.065032 3616.99772,223.999394 C3597.24657,223.82367 3589,203.495306 3589,186.60962 C3589,159.975495 3599.46911,151.000663 3616.99772,151.000663 C3632.73071,150.913624 3650.19374,159.367976 3645.87036,191.060783 Z",
      "id": "boy2_face",
      "fill": "#80A259",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy2_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3608.32575,217 C3609.47905,217 3619.49181,217 3620.78027,217 C3622.06873,217 3617.44625,215 3613.29344,215 C3609.14062,215 3607.17245,217 3608.32575,217 Z",
      "fill": "#94B96B",
      "transform": "translate(3614.500000, 216.000000) scale(1, -1) translate(-3614.500000, -216.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3606.40093,214 C3607.82037,214 3620.14376,214 3621.72956,214 C3623.31536,214 3617.62615,211 3612.515,211 C3607.40384,211 3604.98148,214 3606.40093,214 Z",
      "id": "boy2_mouth_top",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3611.92625,190.149409 C3612.17726,188.666728 3616.20742,188.567797 3616.33881,190.149409 C3616.47019,191.731021 3617.75714,201.290975 3616.34097,202.952387 C3614.92481,204.613799 3610.76182,204.057148 3610.11757,202.952387 C3609.47332,201.847626 3611.67523,191.63209 3611.92625,190.149409 Z",
      "id": "boy2_nose",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3608,192.475587 C3605.71082,187.227013 3595.52997,186.425993 3594,190.971022 C3593.99274,197.108262 3606.33588,197.650327 3608,192.475587 Z",
      "id": "boy2_right_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy2_right_pupil",
      "fill": "#6D8C4A",
      "cx": "3598.5",
      "cy": "192.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3622,192.475587 C3624.28918,187.227013 3634.47003,186.425993 3636,190.971022 C3636.00726,197.108262 3623.66412,197.650327 3622,192.475587 Z",
      "id": "boy2_left_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy2_left_pupil",
      "fill": "#6D8C4A",
      "cx": "3627.5",
      "cy": "192.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3607.97094,183.573047 C3607.52062,181.535821 3593.3042,181.503758 3593.01891,183.323628 C3592.73362,185.143499 3595.71101,184.275769 3599.6296,184.623966 C3603.54819,184.972164 3608.42125,185.610274 3607.97094,183.573047 Z",
      "id": "boy2_right_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3622.02906,183.573047 C3622.47938,181.535821 3636.6958,181.503758 3636.98109,183.323628 C3637.26638,185.143499 3634.28899,184.275769 3630.3704,184.623966 C3626.45181,184.972164 3621.57875,185.610274 3622.02906,183.573047 Z",
      "id": "boy2_left_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3607.12223,163.978435 C3608.55718,168.642139 3612.02078,176.659137 3617.51304,188.029427 L3617.51303,188.029432 C3617.95933,188.953366 3618.84687,189.585122 3619.866,189.704284 L3620.04622,189.725356 L3620.04622,189.725356 C3620.73568,189.80597 3621.35994,189.312408 3621.44056,188.622953 C3621.45838,188.470483 3621.44813,188.316037 3621.4103,188.167262 L3617.09375,171.190834 L3624.58393,187.260024 L3624.58393,187.260024 C3625.07656,188.316909 3626.13698,188.992587 3627.30305,188.992587 L3627.59582,188.992587 L3627.59582,188.992587 C3628.46245,188.992587 3629.16499,188.290043 3629.16499,187.423411 C3629.16499,187.248564 3629.13577,187.074947 3629.07853,186.909735 L3623.0684,169.561589 L3631.36945,186.613039 L3631.36945,186.613039 C3631.76081,187.416935 3632.57654,187.927076 3633.47064,187.927076 L3633.47064,187.927076 L3633.47064,187.927076 C3634.13385,187.927076 3634.67149,187.389438 3634.67149,186.726226 C3634.67149,186.648719 3634.66398,186.571394 3634.64908,186.495332 C3633.29533,179.586179 3632.63818,175.281175 3632.6776,173.580325 C3634.11088,176.006688 3635.91091,182.459064 3638.0777,192.937452 L3638.07773,192.937445 C3638.26534,193.844707 3639.06439,194.495429 3639.99085,194.495429 L3639.99085,194.495429 L3639.99085,194.495429 C3640.76236,194.495429 3641.3878,193.869994 3641.3878,193.09848 C3641.3878,193.038049 3641.38388,192.977682 3641.37606,192.917759 C3640.48318,186.073756 3640.05231,181.312578 3640.08346,178.634225 C3641.51139,181.818269 3643.15881,188.151058 3645.02573,197.632589 L3645.02574,197.632589 C3645.18218,198.427131 3645.87885,199 3646.68865,199 L3646.68865,199 L3646.68865,199 C3647.47728,199 3648.13362,198.394211 3648.1967,197.608112 L3648.64211,192.057606 L3651.94457,197.546605 L3651.94457,197.546605 C3652.48716,198.448452 3653.46268,199 3654.51517,199 L3654.60713,199 L3654.60713,199 C3655.37013,199 3655.98866,198.381469 3655.98866,197.618472 C3655.98866,197.500807 3655.97363,197.383624 3655.94393,197.269769 L3651.2624,179.322578 L3657.21945,190.171524 L3657.21945,190.171524 C3657.78403,191.199723 3659.07523,191.575564 3660.10342,191.01099 C3660.11149,191.00656 3660.11953,191.002077 3660.12754,190.997542 L3660.12754,190.997542 L3660.12754,190.997542 C3661.17847,190.402578 3661.58238,189.090822 3661.04815,188.007762 L3651.94938,169.561589 L3658.20371,174.018238 L3658.20371,174.018238 C3659.06235,174.630075 3660.2544,174.430006 3660.86623,173.571372 C3660.88369,173.546874 3660.90057,173.521967 3660.91684,173.496671 L3660.91684,173.496671 L3660.91684,173.496671 C3661.5335,172.538497 3661.33112,171.269888 3660.44696,170.551133 L3648.01855,160.447836 L3656.16089,162.709776 L3656.16089,162.709776 C3657.35005,163.040125 3658.59619,162.416363 3659.04439,161.266425 L3659.04439,161.266425 L3659.04439,161.266425 C3659.46666,160.182985 3658.93069,158.962359 3657.84725,158.540081 C3657.82646,158.531979 3657.80554,158.524208 3657.78451,158.516771 L3627.45711,147.793768 L3638.42709,144.062516 L3638.42709,144.062516 C3639.41746,143.725659 3640.08346,142.795653 3640.08346,141.749565 L3640.08346,141.749565 L3640.08346,141.749565 C3640.08346,140.835142 3639.34218,140.093856 3638.42775,140.093856 C3638.39079,140.093856 3638.35384,140.095093 3638.31696,140.097567 C3626.2681,140.905668 3615.41914,144.574494 3605.77009,151.104078 C3595.4086,153.100607 3586.50956,159.713358 3579.07296,170.942331 L3579.07294,170.942316 C3578.44707,171.887356 3578.61729,173.149714 3579.47112,173.895223 L3579.47112,173.895223 L3579.47112,173.895223 C3580.24437,174.570374 3581.41854,174.490848 3582.09369,173.717598 C3582.11384,173.69451 3582.13343,173.670927 3582.15242,173.646871 L3588.11868,166.089837 L3578.79851,186.20381 L3578.79851,186.20381 C3578.41899,187.022846 3578.77529,187.994464 3579.59433,188.373979 C3579.66831,188.408261 3579.74476,188.436959 3579.82303,188.459832 L3579.82303,188.459832 L3579.82303,188.459832 C3580.87216,188.766425 3581.98817,188.262497 3582.45195,187.272764 L3588.11868,175.179711 L3585.18898,189.899326 L3585.18898,189.899326 C3585.01678,190.764511 3585.57855,191.605479 3586.44374,191.77768 C3586.4601,191.780937 3586.47651,191.783936 3586.49297,191.786679 L3586.49297,191.786679 L3586.49297,191.786679 C3587.43137,191.943064 3588.34546,191.398752 3588.65508,190.499207 L3595.86186,169.561589 L3593.95498,186.698874 L3593.95498,186.698874 C3593.8542,187.604529 3594.50669,188.420401 3595.41234,188.521174 C3595.47293,188.527916 3595.53385,188.531294 3595.59481,188.531294 L3595.59481,188.531294 L3595.59481,188.531294 C3596.66832,188.531294 3597.59405,187.776937 3597.81079,186.725536 L3601.73894,167.670732 L3601.27824,187.144419 L3601.27824,187.144419 C3601.25331,188.19846 3602.02096,189.104443 3603.06479,189.25291 L3603.06479,189.25291 L3603.06479,189.25291 C3604.01969,189.388728 3604.90389,188.72473 3605.03971,187.769829 C3605.04436,187.737092 3605.04809,187.70423 3605.05088,187.671281 C3606.1357,174.862001 3606.82614,166.964385 3607.12223,163.978435 Z",
      "id": "boy2_hair",
      "fill": "#6D8C4A"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5457dc28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/boy2.vue
// module id = 703
// module chunks = 1